<template>
    <Toast />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Notification Settings</h5>
                <div>
                    <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
                    <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious"
                        icon="pi pi-chevron-left" />
                    <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm"
                        iconPos="right" />
                </div>
            </div>
            <div class="card p-mt-4">
                <DataTable :value="notification" :lazy="true" :paginator="true" :rows="30" :totalRecords="totalRecords"
                    :loading="loading" @page="onPage($event)" class="p-datatable-users" dataKey="mbz1" :rowHover="true"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                    <Toolbar>
                        <template v-slot:left>
                            <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : '-' }} </h6>
                        </template>
                        <template v-slot:right>
                            <Button label="Add Notification" icon="pi pi-plus" @click="toDynamicMessage" />
                        </template>
                    </Toolbar>
                    <template #empty> No data found. </template>
                    <template #loading> Loading data. Please wait... </template>
                    <Column headerStyle="width: 2%" class="align-center"></Column>
                    <Column field="id" header="Sr." headerStyle="width: 5%">
                        <template #body="{ index }">
                            <div>{{ genrateSrNo(index) }}</div>
                        </template>
                    </Column>
                    <Column header="Date & Time" class="p-text-capitalize" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <div>
                                {{ format_datetime(data.z501) }}
                            </div>
                        </template>
                    </Column>
                    <Column header="Title" field="qc2" class="p-text-capitalize" headerStyle="width: 20%">
                    </Column>
                    <Column header="Content" field="qc3" class="p-text-capitalize" headerStyle="width: 7%">
                        <template #body="{ data }">
                            <div>
                                <span v-if="data.qc5 != null && data.qc5 != ''">
                                    <img :src="data.qc5" width="50" style="vertical-align: middle" class="mb-2" />
                                </span>
                                <span v-if="data.qc5 == null || data.qc5 == ''">-</span>
                            </div>
                        </template>
                    </Column>
                    <Column field="qc3" class="p-text-capitalize" headerStyle="width: 30%">
                        <template #body="{ data }">
                            <div>
                                <span class="overflow-text">{{ data.qc3 ? data.qc3 : '-' }}</span>
                            </div>
                        </template>
                    </Column>
                    <Column header="Status" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <span v-if="data.qc6 == 1" :class="'user-badge status-active'">Active</span>
                            <span v-if="data.qc6 == 0" :class="'user-badge status-temp-suspend'">Inactive</span>
                        </template>
                    </Column>
                    <Column header="Action" headerStyle="width: 15%">
                        <template #body="{ data }">
                            <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                @click="editDynamicMessageModalOpen(data)" />
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
    <!-- Add Role Dialog starts here -->
    <!-- Add Role Dialog starts here -->
    <Dialog v-model:visible="isAddReport" :style="{ width: '1000px' }" :modal="true" class="p-fluid"
        header="Add Notification">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="screentitle">Title <span class="p-invalid p-error">*</span></label>
                        <InputText id="screentitle" v-model="screentitle" required="true" maxlength="200"
                            placeholder="Enter Title" :class="{ 'p-invalid': isSubmitted && !screentitle }" />
                        <small class="p-invalid p-error" v-if="v$.screentitle.$error">{{
                            v$.screentitle.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="sendDateTime">Send Date & Time</label>
                        <Calendar id="sendDateTime" v-model="sendDateTime" showTime hourFormat="24"
                            :minDate="new Date()" dateFormat="yy-mm-dd" placeholder="Select Date & Time" />
                    </div>
                    <div class="p-field p-col-12 p-md-12">
                        <label for="dynamiccontent">Content <span class="p-invalid p-error">*</span></label>
                        <Textarea id="dynamiccontent" v-model="dynamiccontent" :autoResize="true" rows="3" cols="30"
                            placeholder="Enter Content" :class="{ 'p-invalid': isSubmitted && !message }"></textarea>
                        <!-- <InputText id="dynamiccontent" v-model="dynamiccontent" required="true" maxlength="30"
                            placeholder="Enter State Code" /> -->
                        <small class="p-invalid p-error" v-if="v$.dynamiccontent.$error">{{
                            v$.dynamiccontent.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="countrylogo">Media (Image)</label>
                        <FileUpload mode="basic" v-model="notificationImage" ref="notificationImage" accept="image/*"
                            :maxFileSize="1000000" chooseLabel="Upload Media" auto @select="onSelectProfile">
                        </FileUpload>
                        <span v-if="profileUrl != ''">
                            <img class="p-pt-2" role="presentation" :alt="profileUrl.name" :src="profileUrl.url"
                                width="120" height="120" />
                        </span>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Attachment</label>
                        <FileUpload mode="basic" :auto="true" :chooseLabel="'Select PDF'" :maxFileSize="2000000"
                            accept=".pdf,application/pdf" @select="onSelectAttachment" />
                        <span v-if="attachment" class="p-ml-2 p-success">{{ attachment.name }}</span>
                    </div>
                    <!-- URLs -->
                    <div class="p-field p-col-12">
                        <label>URLs</label>
                        <div v-for="(url, index) in urls" :key="'url-' + index" class="p-grid p-ai-center p-mb-2">
                            <div class="p-col-12 p-md-4">
                                <InputText v-model="urls[index].name" placeholder="Enter Button Label" />
                            </div>
                            <div class="p-col-12 p-md-7">
                                <InputText v-model="urls[index].value" placeholder="Enter URL" />
                            </div>
                            <div class="p-col-12 p-md-1 text-center" v-if="urls.length > 1">
                                <Button icon="pi pi-trash" class="p-button p-button-sm"
                                    @click="removeField('urls', index)" />
                            </div>
                        </div>
                        <Button label="Add More" icon="pi pi-plus" class="p-button-text" @click="addField('urls')"
                            :disabled="urls.length >= 3" />
                    </div>

                    <!-- Mobiles -->
                    <div class="p-field p-col-12">
                        <label>Mobile Numbers</label>
                        <div v-for="(mobile, index) in mobiles" :key="'mobile-' + index"
                            class="p-grid p-ai-center p-mb-2">
                            <div class="p-col-12 p-md-4">
                                <InputText v-model="mobiles[index].name" placeholder="Enter Button Label" />
                            </div>
                            <div class="p-col-12 p-md-7">
                                <InputText v-model="mobiles[index].value" placeholder="Enter Mobile Number"
                                    @input="mobile.value = mobile.value.replace(/[^0-9]/g, '')" maxlength="10" />
                            </div>
                            <div class="p-col-12 p-md-1 text-center" v-if="mobiles.length > 1">
                                <Button icon="pi pi-trash" class="p-button p-button-sm"
                                    @click="removeField('mobiles', index)" />
                            </div>
                        </div>
                        <Button label="Add More" icon="pi pi-plus" class="p-button-text" @click="addField('mobiles')"
                            :disabled="mobiles.length >= 3" />
                    </div>

                    <!-- Emails -->
                    <div class="p-field p-col-12">
                        <label>Emails</label>
                        <div v-for="(email, index) in emails" :key="'email-' + index" class="p-grid p-ai-center p-mb-2">
                            <div class="p-col-12 p-md-4">
                                <InputText v-model="emails[index].name" placeholder="Enter BSutton Label" />
                            </div>
                            <div class="p-col-12 p-md-7">
                                <InputText v-model="emails[index].value" placeholder="Enter Email" />
                            </div>
                            <div class="p-col-12 p-md-1 text-center" v-if="emails.length > 1">
                                <Button icon="pi pi-trash" class="p-button p-button-sm"
                                    @click="removeField('emails', index)" />
                            </div>
                        </div>
                        <Button label="Add More" icon="pi pi-plus" class="p-button-text" @click="addField('emails')"
                            :disabled="emails.length >= 3" />
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="addDynamicMessage" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Add Role Dialog ends here -->

    <!-- Edit Role Dialog starts here -->
    <Dialog v-model:visible="isEditUserRole" header="Edit Message" :style="{ width: '800px' }" :modal="true"
        class="p-fluid">
        <div style="position: relative" v-if="!showLoader">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-6">
                        <label for="screentitle">Title<span class="p-invalid p-error">*</span></label>
                        <InputText id="screentitle" v-model="screentitle" required="true" maxlength="200"
                            placeholder="Enter Screen Title" :class="{ 'p-invalid': isSubmitted && !screentitle }" />
                        <small class="p-invalid p-error" v-if="v$.screentitle.$error">{{
                            v$.screentitle.$errors[0].$message
                            }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="sendDateTime">Send Date & Time</label>
                        <Calendar id="sendDateTime" v-model="sendDateTime" showTime hourFormat="24"
                            :minDate="new Date()" dateFormat="yy-mm-dd" placeholder="Select Date & Time" />
                    </div>
                    <div class="p-field p-col-12 p-md-12">
                        <label for="dynamiccontent">Content <span class="p-invalid p-error">*</span></label>
                        <Textarea id="dynamiccontent" v-model="dynamiccontent" :autoResize="true" rows="3" cols="30"
                            placeholder="Enter Message" :class="{ 'p-invalid': isSubmitted && !message }"></textarea>
                        <!-- <InputText id="dynamiccontent" v-model="dynamiccontent" required="true" maxlength="30"
                            placeholder="Enter State Code" /> -->
                        <small class="p-invalid p-error" v-if="v$.dynamiccontent.$error">{{
                            v$.dynamiccontent.$errors[0].$message
                        }}</small>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label for="countrylogo">Media (Image)</label>
                        <FileUpload mode="basic" v-model="notificationImage" ref="notificationImage" accept="image/*"
                            :maxFileSize="1000000" chooseLabel="Upload Media" auto @select="onSelectProfile">
                        </FileUpload>
                        <span v-if="profileUrl != ''">
                            <img class="p-pt-2" role="presentation" :alt="profileUrl.name" :src="profileUrl.url"
                                width="120" height="120" />
                        </span>
                    </div>
                    <div class="p-field p-col-12 p-md-6">
                        <label>Attachment</label>
                        <FileUpload mode="basic" :auto="true" :chooseLabel="'Select File'" :maxFileSize="2000000"
                            @select="onSelectAttachment" />
                        <span v-if="attachment" class="p-ml-2">
                            <a :href="attachment.url" target="_blank">{{ attachment.name }}</a>
                        </span>
                    </div>
                    <!-- URLs -->
                    <div class="p-field p-col-12">
                        <label>URLs</label>
                        <div v-for="(url, index) in urls" :key="'url-' + index" class="p-grid p-ai-center p-mb-2">
                            <div class="p-col-12 p-md-4">
                                <InputText v-model="urls[index].name" placeholder="Enter Button Label" />
                            </div>
                            <div class="p-col-12 p-md-7">
                                <InputText v-model="urls[index].value" placeholder="Enter URL" />
                            </div>
                            <div class="p-col-12 p-md-1 text-center" v-if="urls.length > 1">
                                <Button icon="pi pi-trash" class="p-button p-button-sm"
                                    @click="removeField('urls', index)" />
                            </div>
                        </div>
                        <Button label="Add More" icon="pi pi-plus" class="p-button-text" @click="addField('urls')"
                            :disabled="urls.length >= 3" />
                    </div>

                    <!-- Mobiles -->
                    <div class="p-field p-col-12">
                        <label>Mobile Numbers</label>
                        <div v-for="(mobile, index) in mobiles" :key="'mobile-' + index"
                            class="p-grid p-ai-center p-mb-2">
                            <div class="p-col-12 p-md-4">
                                <InputText v-model="mobiles[index].name" placeholder="Enter Button Label" />
                            </div>
                            <div class="p-col-12 p-md-7">
                                <InputText v-model="mobiles[index].value" placeholder="Enter Mobile Number"
                                    @input="mobile.value = mobile.value.replace(/[^0-9]/g, '')" maxlength="10" />
                            </div>
                            <div class="p-col-12 p-md-1 text-center" v-if="mobiles.length > 1">
                                <Button icon="pi pi-trash" class="p-button p-button-sm"
                                    @click="removeField('mobiles', index)" />
                            </div>
                        </div>
                        <Button label="Add More" icon="pi pi-plus" class="p-button-text" @click="addField('mobiles')"
                            :disabled="mobiles.length >= 3" />
                    </div>

                    <!-- Emails -->
                    <div class="p-field p-col-12">
                        <label>Emails</label>
                        <div v-for="(email, index) in emails" :key="'email-' + index" class="p-grid p-ai-center p-mb-2">
                            <div class="p-col-12 p-md-4">
                                <InputText v-model="emails[index].name" placeholder="Enter Button Label" />
                            </div>
                            <div class="p-col-12 p-md-7">
                                <InputText v-model="emails[index].value" placeholder="Enter Email"
                                    @blur="validateEmail(email)" />
                                <span v-if="email.error" class="p-error">{{ email.error }}</span>
                            </div>
                            <div class="p-col-12 p-md-1 text-center" v-if="emails.length > 1">
                                <Button icon="pi pi-trash" class="p-button p-button-sm"
                                    @click="removeField('emails', index)" />
                            </div>
                        </div>
                        <Button label="Add More" icon="pi pi-plus" class="p-button-text" @click="addField('emails')"
                            :disabled="emails.length >= 3" />
                    </div>
                    <div class="p-field p-col-12 p-md-8">
                        <label>Status</label>
                        <Dropdown id="adminstatus" v-model="adminstatus" :options="adminstatusList" optionLabel="label"
                            placeholder="Select ..." appendTo="body"></Dropdown>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="`pi ${!showLoaderAddBtn ? 'pi-check' : 'pi-spin pi-spinner indigo-color'}`"
                class="p-button-text p-ml-auto" @click="editDynamicMessage(rowData)" style="width: 90px;"></Button>
        </template>
    </Dialog>
    <!-- Edit Role Dialog ends here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useRoute } from 'vue-router';
import { useConfirm } from "primevue/useconfirm";
import router from '@/router';
import { required, helpers } from '@vuelidate/validators';
import CommonMixins from '../../mixins/common-mixins';

export default {
    mixins: [CommonMixins],
    data() {
        return {
            confirm: useConfirm(),
            notification: [],
            v$: useValidate(),
            isAddReport: false,
            isSubmitted: false,
            showLoader: false,
            loading: false,
            page_no: 0,
            totalRecords: 0,
            isEditUserRole: false,
            showLoaderAddBtn: false,
            rowId: '',
            screentitle: '',
            modulesList: [],
            modules: '',
            dynamiccontent: '',
            adminstatus: { label: 'Active', value: 1 },
            adminstatusList: [
                { label: 'Active', value: 1 },
                { label: 'Inactive', value: 0 },
            ],
            isFilter: false,
            stateFilter: '',
            localAdminName: '',
            stateFilterList: [],
            // notification
            profileUrl: '',
            notificationImage: '',
            updatenotificationImage: '',
            profileImageFlag: '',
            imagestorageimgpath: '',
            clientBucketName: '',
            client_logo: '',
            urls: [{ name: '', value: '' }],
            mobiles: [{ name: '', value: '' }],
            emails: [{ name: '', value: '' }],
            attachments: null,
            sendDateTime: null
        };
    },
    validations() {
        return {
            screentitle: { required: helpers.withMessage('Please enter title', required) },
            dynamiccontent: { required: helpers.withMessage('Please enter content', required) },
        };
    },
    ApiService: null,
    created() {
        this.ApiService = new ApiService();
    },
    async mounted() {
        const route = useRoute();
        this.loading = true;
        this.client_info = localStorage.getItem('CLIENT_LOGO');
        this.client_logo = this.client_info;
        this.routeParam = route.params.adminSubId;
        this.localAdminName = localStorage.localAdminName;
        this.getAdminUserDetails({ maa1: this.routeParam });
        this.getClientDashboardMessage({ maa1: this.routeParam });
        this.getAllAdminMenus({ maa1: this.routeParam });
    },
    methods: {
        addField(type) {
            if (this[type].length < 3) {
                this[type].push({ name: '', value: '' })
            }
        },
        removeField(type, index) {
            this[type].splice(index, 1)
        },
        onSelectAttachment(event) {
            const file = event.files[0];
            if (file && file.type === "application/pdf") {
                this.attachment = file;
            } else {
                this.$toast.add({
                    severity: "error",
                    summary: "Invalid File",
                    detail: "Only PDF files are allowed.",
                    life: 3000
                });
                this.attachment = null;
            }
        },
        validateEmail(email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            email.error = email.value && !regex.test(email.value)
                ? "Invalid email format"
                : "";
        },
        getAllAdminMenus() {
            this.ApiService.getAllAdminMenus({ maa1: this.routeParam }).then((items) => {
                if (items.status === 200) {
                    this.modulesList = items.data;
                }
            })
        },
        getAdminUserDetails() {
            this.ApiService.getAdminUserDetails({ maa1: this.routeParam }).then((data) => {
                if (data.status == 200) {
                    this.adminList = data.data.records;
                    this.clientBucketName = this.adminList.maa24;
                    this.showloaderpage = false;
                } else {
                    this.adminList = "";
                    this.showloaderpage = false;
                }
            });
        },
        getClientDashboardMessage() {
            this.totalRecords = 0;
            this.ApiService.getClientDashboardMessage({ maa1: this.routeParam }).then((items) => {
                if (items.status === 200) {
                    this.notification = items.data;
                    this.totalRecords = items.count;
                    this.isFilter = false;
                } else {
                    this.notification = [];
                }
                this.loading = false;
            });
        },
        async toDynamicMessage() {
            this.isAddReport = true;
            this.isSubmitted = false;
            this.screentitle = '';
            this.profileUrl = '';
            this.notificationImage = '';
            this.dynamiccontent = '';
            this.modules = '';
            this.adminstatus = { label: 'Active', value: 1 };
            this.urls = [{ name: '', value: '' }];
            this.mobiles = [{ name: '', value: '' }];
            this.emails = [{ name: '', value: '' }];
            this.attachment = null;
            this.sendDateTime = null;
            this.v$.$reset();
        },
        addDynamicMessage() {
            this.submitted = true;
            this.errormsg = '';
            this.v$.$validate();
            let formData = new FormData();
            formData.append('maa1', this.routeParam);
            formData.append('qc2', this.screentitle);
            formData.append('qc3', this.dynamiccontent);
            // formData.append('qc5', this.notificationImage);
            if (this.notificationImage) {
                formData.append('qc4', this.notificationImage);
            }

            const urlsObj = this.urls.filter(u => u.name && u.value);
            const mobilesObj = this.mobiles.filter(m => m.name && m.value);
            const emailsObj = this.emails.filter(e => e.name && e.value);

            formData.append('qc8', JSON.stringify(urlsObj))
            formData.append('qc9', JSON.stringify(mobilesObj))
            formData.append('qc10', JSON.stringify(emailsObj))

            if (this.attachment) {
                formData.append('qc11', this.attachment);
            }
            if (this.sendDateTime) {
                formData.append('qc12', this.sendDateTime.toISOString());
            }

            formData.append('qc6', 1);
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateClientDashboardMessage(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getClientDashboardMessage({ page_no: this.page_no });
                        this.isAddReport = false;
                        this.screentitle = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        editDynamicMessageModalOpen(data) {
            this.isEditUserRole = true;
            this.screentitle = '';
            this.dynamiccontent = '';
            this.adminstatus = '',
                this.profileUrl = '';
            this.notificationImage = '';
            this.updatenotificationImage = '';
            this.profileImageFlag = '';
            this.emails = [{ name: '', value: '' }];
            this.urls = [{ name: '', value: '' }];
            this.mobiles = [{ name: '', value: '' }];
            this.attachment = null;
            this.sendDateTime = null;
            this.rowId = data.qc1;
            this.screentitle = data.qc2;
            this.dynamiccontent = data.qc3;
            if (data.qc5) {
                this.profileUrl = { url: data.qc5, name: data.qc5.split('/').pop() };
                this.notificationImage = data.qc5;
                this.updatenotificationImage = this.notificationImage;
            } else {
                this.profileUrl = '';
                this.notificationImage = '';
            }
            this.profileImageFlag = data.qc5;
            // this.profileUrl = data.qc5,
            this.adminstatus = this.adminstatusList.find((item) => item.value == data.qc6);
            this.urls = this.normalizeField(data.qc8);
            this.mobiles = this.normalizeField(data.qc9);
            this.emails = this.normalizeField(data.qc10);
            this.attachment = data.qc11
                ? { name: data.qc11.split("/").pop(), url: data.qc11 }
                : null;
            this.sendDateTime = data.qc12 ? new Date(data.qc12) : null;

        },
        normalizeField(field) {
            if (!field) return [{ name: "", value: "" }];
            if (Array.isArray(field)) {
                return field;
            }
            if (typeof field === "object") {
                return Object.entries(field).map(([k, v]) => ({
                    name: k,
                    value: v
                }));
            }
            if (typeof field === "string") {
                try {
                    const parsed = JSON.parse(field);
                    if (Array.isArray(parsed)) return parsed;
                    if (typeof parsed === "object") {
                        return Object.entries(parsed).map(([k, v]) => ({
                            name: k,
                            value: v
                        }));
                    }
                } catch (e) {
                    console.error("Invalid field JSON:", field, e);
                }
            }
            return [{ name: "", value: "" }];
        },
        editDynamicMessage() {
            this.submitted = true;
            this.errormsg = '';
            let formData = new FormData();
            formData.append('maa1', this.routeParam);
            formData.append('qc1', this.rowId);
            formData.append('qc2', this.screentitle);
            formData.append('qc3', this.dynamiccontent);
            if (this.notificationImage != this.updatenotificationImage) {
                formData.append('qc4', this.notificationImage);
            }
            formData.append('qc6', this.adminstatus.value);
            const urlsObj = this.urls.filter(u => u.name && u.value);
            const mobilesObj = this.mobiles.filter(m => m.name && m.value);
            const emailsObj = this.emails.filter(e => e.name && e.value);

            formData.append('qc8', JSON.stringify(urlsObj));
            formData.append('qc9', JSON.stringify(mobilesObj));
            formData.append('qc10', JSON.stringify(emailsObj));

            if (this.attachment && this.attachment instanceof File) {
                formData.append("qc11", this.attachment);
            }
            if (this.sendDateTime) {
                const pad = n => (n < 10 ? "0" + n : n);
                const d = this.sendDateTime;
                const formatted =
                    d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate()) + " " +
                    pad(d.getHours()) + ":" + pad(d.getMinutes()) + ":" + pad(d.getSeconds());

                formData.append("qc12", formatted);
            }
            this.v$.$validate();
            if (!this.v$.$error) {
                this.showLoaderAddBtn = true;
                this.ApiService.insertOrUpdateClientDashboardMessage(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoaderAddBtn = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.getClientDashboardMessage({ page_no: this.page_no });
                        this.isEditUserRole = false;
                        this.screentitle = '';
                    } else {
                        this.showLoaderAddBtn = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getClientDashboardMessage({ page_no: event.page });
        },
        goToDashboard() {
            router.push({
                name: "admindashboard",
                params: { adminId: this.routeParam },
            });
        },
        goToPrevious() {
            router.push({
                name: "admindynamicmessage",
                params: { adminSubId: this.routeParam },
            });
        },
        goToNext() {
            router.push({
                name: "paymentgatewaydetails",
                params: { adminSubId: this.routeParam },
            });
        },
        async onSelectProfile(e) {
            this.profileImage = e.files[0];
            const file = e.files[0];
            let allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i;
            if (!file.size > 2048) {
                this.profileImageError = 'File size cannot exceed more than 2MB';
                this.profileImage = '';
            } else if (!file.name.match(allowedExtensions)) {
                this.profileImageError = 'Invalid file type';
                this.profileImage = '';
            } else {
                this.profileImageError = '';
                if (file && file.type.includes('image/')) {
                    this.profileUrl = { url: file.objectURL, name: file.name };
                    this.profileImage = e.files[0];
                    this.notificationImage = e.files[0];
                    // this.profileImageFlag = null;
                } else {
                    this.profileImageError = 'Invalid file type';
                    this.profileImage = '';
                }
            }
        },

    }
};
</script>

<style scoped></style>
